import React, { useState, useEffect } from 'react';
import '../Style/Approvals.css';

const Approvals = ({ rolloutData = {}, onBackToList }) => {
  // State to track if the 'Approve' button has been clicked
  const [isApproved, setIsApproved] = useState(false);

  // Chart Data for the Pie Chart visualization
  const chartData = [
    { name: "Pending", value: 5, color: "#A0AEC0" },
    { name: "In Progress", value: 2, color: "#4299E1" },
    { name: "Aborted", value: 0, color: "#FC8181" },
    { name: "Failed", value: 0, color: "#F56565" },
    { name: "Complete", value: 0, color: "#48BB78" },
  ];

  // Data for the horizontal progress bars
  const progressBars = [
    { label: "Request Received", current: 2, max: 10, color: "#8B5F29" },
    { label: "Package Downloading", current: 2, max: 10, color: "#4299E1" },
    { label: "Update Staging", current: 0, max: 10, color: "#A0AEC0" },
    { label: "Waiting For Preconditions", current: 0, max: 10, color: "#A0AEC0" },
    { label: "Update In Progress", current: 0, max: 10, color: "#A0AEC0" },
    { label: "Attempting Abort", current: 0, max: 10, color: "#A0AEC0" },
  ];

  useEffect(() => {
    // Only draw the chart if we are in the 'Approved' state
    if (!isApproved) return;

    const canvas = document.getElementById("approvalPhasesChart");
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const radius = Math.min(centerX, centerY) * 0.9;

    let total = chartData.reduce((sum, item) => sum + item.value, 0);
    let startAngle = -Math.PI / 2;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    chartData.forEach(slice => {
      if (slice.value === 0) return;
      const sliceAngle = (slice.value / total) * 2 * Math.PI;
      ctx.beginPath();
      ctx.moveTo(centerX, centerY);
      ctx.arc(centerX, centerY, radius, startAngle, startAngle + sliceAngle);
      ctx.closePath();
      ctx.fillStyle = slice.color;
      ctx.fill();
      startAngle += sliceAngle;
    });
  }, ); 

  // commented inside content for warning purpose [isApproved]

  return (
    <div className="Approvals-wrapper">
      <div className="Approvals-container">
        {/* Header Section */}
        <div className="Approvals-header">
          <div className="Approvals-title-group">
            <h1 className="Approvals-title">
              {rolloutData.rolloutName || "Demo Rollout 6/6"}
            </h1>
            <span className="Approvals-success-badge">
              <span className="dot-green"></span>
              Successfully Created Rollout
            </span>
          </div>
          <div className="Approvals-actions">
            {/* <button onClick={onBackToList} className="btn-back">
              {isApproved ? "← Back to Rollout Details" : "← Back to Deployments"}
            </button> */}
            {/* <div className="Approvals-actions buttons"> */}
            <button className="btn-outline">Edit</button>
            <button className="btn-blue">Overview</button>
            <button className="btn-red">Abort</button>
            {/* </div> */}
          </div>
        </div>

        {/* Top Info Cards Grid */}
        <div className="Approvals-content-grid">
          <div className="Approvals-card info-card">
            <h2 className="card-title">Rollout Info</h2>
            <div className="info-grid-layout">
              <div className="info-block"><label>Package Name</label><p>Thunderbolt Package</p></div>
              <div className="info-block"><label>Package Version</label><p>101</p></div>
              <div className="info-block"><label>Package Git Hash</label><p>dc5e043e8e</p></div>
              <div className="info-block"><label>Scheduled Time</label><p>Not scheduled</p></div>
              <div className="info-block"><label>Start Time</label><p>Not yet started</p></div>
              <div className="info-block"><label>End Time</label><p>-</p></div>
            </div>
            <div className="info-footer-group">
              <label>Vehicle Groups</label>
              <p>Demo Group 6/6</p>
            </div>
          </div>

          <div className="Approvals-card approver-card">
            <h2 className="card-title">Approvers</h2>
            <div className="approver-detail">
              <label>Demo Account (Owner)</label>
              <div className="approver-status">
                <p>Demo Account</p>
                {isApproved && <span className="check-mark">✓</span>}
              </div>
            </div>
            <div className="approval-button-group">
              {!isApproved ? (
                <button className="btn-blue" onClick={() => setIsApproved(true)}>Approve</button>
              ) : (
                <button className="btn-disabled" disabled>Approved</button>
              )}
              <button className="btn-red">Deny</button>
            </div>
          </div>
        </div>

        {/* Phases Completed Section - Conditionallly rendered or displayed after Approval */}
        {isApproved && (
          <div className="Phases-section">
            <h2 className="Phases-title">Phases Completed</h2>
            <div className="Phases-card-layout">
              {/* Pie Chart Column */}
              <div className="Phases-chart-column">
                <canvas id="approvalPhasesChart" width="180" height="180"></canvas>
                  <div className="Phases-legend">
                    {chartData.map((item, idx) => (
                      <div key={idx} className="legend-row">
                        <span className="dot" style={{ backgroundColor: item.color }}><span className="label">{item.name}</span></span>
                        
                        {/* <span className="value">{item.value}</span> */}
                        <div><span className="val">{item.value}</span>
                      </div>
                      </div>
                    ))}
                  <div className="targeted-total">
                    <span>Total Vehicles Targeted <strong>7</strong></span>
                  </div>
                </div>
              </div>

              {/* Progress Bars Column */}
              <div className="Phases-bars-column">
                {progressBars.map((bar, idx) => (
                  <div key={idx} className="bar-row">
                    <span className="bar-label">{bar.label}</span>
                    <div className="bar-track">
                      <div 
                        className="bar-fill" 
                        style={{ 
                          width: `${(bar.current / bar.max) * 100}%`, 
                          backgroundColor: bar.color 
                        }}
                      ></div>
                    </div>
                    <span className="bar-stats">{bar.current}/{bar.max}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Approvals;